import { http } from '../utils/http/index'

export class HomeApi {
  // 获取公园列表
  async getParks() {
    return http.get('/auth/getParks')
  }

  // 获取园区设置
  async getParkSetting(params: any) {
    return http.get('/auth/getSetting', params)
  }

  // 获取轮播图列表
  async getBannerList(params?: any) {
    return http.get('/banner/getList', params)
  }

  // 获取活动列表
  async getActivityList(params?: any) {
    return http.get('/activity/getList', params)
  }

  // 园区活动详情
  async getParkActiveDetail(params?: any) {
    return http.get('/activity/detail', params)
  }

  // 园区活动点赞
  async setParkActiveLike(params?: any) {
    return http.post('/auth/setLike', params)
  }

  // 园区活动报名
  async applyParkActive(params?: any) {
    return http.post('/activity/apply', params)
  }

  // 园区活动报名列表
  async getParkActiveApplyList(params?: any) {
    return http.get('/activity/myApplies', params)
  }

  // 园区活动报名详情
  async getParkActiveApplyDetail(params?: any) {
    return http.get('/activity/myApplyDetail', params)
  }

  // 获取动态列表
  async getDynamicMenu(params?: any) {
    return http.get('/category/getList', params)
  }

  // 获取园区动态列表
  async getParkDynamicList(params?: any) {
    return http.get('/updates/parkList', params)
  }

  // 园区发布动态
  async publishParkDynamic(params?: any) {
    return http.post('/updatespark/add', params)
  }

  // 获取园区动态详情
  async getParkDynamicDetail(params?: any) {
    return http.get('/updatespark/detail', params)
  }

  // 获取企业动态列表
  async getEnterpriseDynamicList(params?: any) {
    return http.get('/updates/companyList', params)
  }

  // 获取企业动态列表
  async getMyEnterpriseDynamicList(params?: any) {
    return http.get('/updatescompany/getMyList', params)
  }

  // 企业发布动态
  async publishEnterpriseDynamic(params?: any) {
    return http.post('/updatescompany/add', params)
  }

  // 企业动态详情
  async getEnterpriseDynamicDetail(params?: any) {
    return http.get('/updatescompany/detail', params)
  }

  // 获取个人动态列表
  async getPersonDynamicList(params?: any) {
    return http.get('/updates/personList', params)
  }

  // 获取个人动态列表
  async getMyPersonDynamicList(params?: any) {
    return http.get('/updatesperson/getMyList', params)
  }

  // 个人发布动态
  async publishPersonDynamic(params?: any) {
    return http.post('/updatesperson/add', params)
  }

  // 个人动态详情
  async getPersonDynamicDetail(params?: any) {
    return http.get('/updatesperson/detail', params)
  }

  // 获取公告列表
  async getAnnouncementsList(params?: any) {
    return http.get('/announcements/getList', params)
  }

  // 获取公告详情
  async getAnnouncementsDetail(params?: any) {
    return http.get('/announcements/getDetail', params)
  }

  // 获取置顶公告
  async getTopAnnouncements(params?: any) {
    return http.get('/announcements/getTop', params)
  }

  // 获取置顶公告列表
  async getTopAnnouncementsList(params?: any) {
    return http.get('/announcements/getTopList', params)
  }

  // 获取用户协议
  async getAgreementDetail(params?: any) {
    return http.get('/documents/detail', params)
  }

  // 首页搜索结果列表
  async getHomeSearchList(params?: any) {
    return http.get('/search/resultList', params)
  }
}
